import React, {useCallback} from 'react';
import Typography from '@material-ui/core/Typography';
import {AreaPopupProps} from './index';
import PopupCloseButton from '../PopupCloseButton';
import AreaStats from '../../AreaStats';

export default function NonWritableAreaPopup(props: AreaPopupProps) {
    const {areas, onPopupChange} = props;
    const area = areas[props.areaLocalId];
    const {notes, title, name, id} = area.properties;
    const pathname = `/datasummary/area/${id}/`;

    return <div style={{maxWidth: 250}}>
        <PopupCloseButton onClick={useCallback(() => onPopupChange(undefined), [onPopupChange])} />

        <Typography variant='body1' style={{fontWeight: 'bold'}} >
            <a rel='noopener noreferrer' href={pathname}>
                {title || name}
            </a>
        </Typography>

        <Typography variant='caption' style={{whiteSpace: 'pre-wrap'}}>{notes}</Typography>

        <AreaStats area={area} style={{flex: 1}} />
    </div>;
}
